import { Box, BoxProps, Card, CardProps, Container, ContainerProps } from 'theme-ui';

import Overlay, { OverlayProps } from './Overlay';
import { IconButton } from '../IconButton';

export interface DialogProps extends BoxProps {
  cardProps?: CardProps;
  closeButtonSize?: number;
  containerProps?: ContainerProps;
  onClose?: (event: React.UIEvent<HTMLButtonElement, MouseEvent>) => void;
  overlayProps?: OverlayProps;
}

const Dialog: React.FC<DialogProps> = ({
  cardProps,
  children,
  closeButtonSize,
  onClose,
  containerProps,
  overlayProps,
  ...props
}) => (
  <Box
    role="dialog"
    {...props}
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      height: '100vh',
      zIndex: 'top'
    }}
  >
    <Container {...containerProps} ref={null}>
      <Card
        variant="white"
        {...cardProps}
        sx={{
          display: 'flex',
          flexFlow: 'column',
          position: 'relative',
          top: '9rem',
          px: 's',
          py: 'm',
          backgroundColor: 'veloWhite',
          overflow: 'auto',
          ...cardProps?.sx
        }}
      >
        <IconButton
          as="button"
          type="button"
          aria-label="Close"
          icon="CancelSmall"
          iconProps={{ width: closeButtonSize, height: closeButtonSize }}
          onClick={onClose}
          sx={{ alignSelf: 'flex-end', textTransform: 'none', color: 'text' }}
          variant="text"
        />
        {children}
      </Card>
    </Container>
    <Overlay {...overlayProps} />
  </Box>
);

Dialog.defaultProps = {
  closeButtonSize: 16
};

export default Dialog;
